export default function () {
    const root = document.querySelector('[data-accordion="pessoas"]');
    if (!root) return;

    const items = Array.from(root.querySelectorAll("[data-accordion-item]"));
    if (!items.length) return;

    const closeItem = (item) => {
        const btn = item.querySelector(".c-pessoa__head");
        const panel = item.querySelector(".c-pessoa__body");
        if (!btn || !panel) return;

        btn.setAttribute("aria-expanded", "false");
        panel.hidden = true;
        item.classList.remove("is-open");
    };

    const openItem = (item) => {
        const btn = item.querySelector(".c-pessoa__head");
        const panel = item.querySelector(".c-pessoa__body");
        if (!btn || !panel) return;

        btn.setAttribute("aria-expanded", "true");
        panel.hidden = false;
        item.classList.add("is-open");
    };

    items.forEach((item, index) => {
        const btn = item.querySelector(".c-pessoa__head");
        const panel = item.querySelector(".c-pessoa__body");
        if (!btn || !panel) return;

        if (index === 0) {
            openItem(item);
        } else {
            closeItem(item);
        }

        btn.addEventListener("click", () => {
            const isOpen = btn.getAttribute("aria-expanded") === "true";
            items.forEach((it) => closeItem(it));
            if (!isOpen) openItem(item);
        });
    });
}
